// Client-side mirror of backend/src/routes/requestRoutes.js's lineSchema /
// backend/src/routes/guestRoutes.js's identical copy — both request lines
// take the exact same shape: { rawDescription: 1-500 chars, rawUnit?: ≤30
// chars, qty: positive, ≤3 decimals }. This is a real, working client-side
// pre-check, never a replacement for the server's own validation.
//
// qty is hand-written here, NOT imported from shared/schemas/
// pricingSchemas.js (that file is zod-based, and root CLAUDE.md's
// performance budgets task pulled zod out of portal's bundle entirely —
// admin/ still imports pricingSchemas.js as-is, per that same task's
// scope: "the backend keeps zod... client validation is only a
// convenience," which applies to admin's own zod use too, just not to
// this file anymore). The regex below (/^\d{1,9}(\.\d{1,3})?$/, positive)
// is kept field-for-field identical to pricingSchemas.js's own qtySchema
// AND to requestRoutes.js's own qtySchema — if either backend schema
// changes, this needs the same change made by hand, same known-gap
// flagged pattern pricingSchemas.js's own header comment already
// documents for itself.
//
// rawDescription/rawUnit were never reused from pricingSchemas.js in the
// first place — descriptionSchema/unitSchema there don't match
// requestRoutes.js's own limits exactly, and "what a buyer typed" vs
// "what a sales rep is pricing" are deliberately kept as separate
// concepts even where a limit happens to coincide.

const QTY_PATTERN = /^\d{1,9}(\.\d{1,3})?$/;

// Same { true | string } contract react-hook-form's `validate` callback
// wants, same two-step check order (shape, then positivity) and same
// messages as pricingSchemas.js's own validateQty — a hand-written
// equivalent of that function's zod chain
// (z.union([z.string(), z.number()]).transform(...).refine(...).refine(...)),
// not a redesign.
export function validateQty(value) {
  const str = typeof value === 'number' ? value.toString() : String(value ?? '').trim();
  if (!QTY_PATTERN.test(str)) {
    return 'Must be a positive number with at most 3 decimal places.';
  }
  if (Number(str) <= 0) {
    return 'Must be greater than zero.';
  }
  return true;
}

export function validateRawDescription(value) {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  if (trimmed === '') return false;
  if (trimmed.length > 500) return false;
  return true;
}

export function validateRawUnit(value) {
  if (value === undefined || value === null || value === '') return true;
  return value.length <= 30;
}

export const RAW_DESCRIPTION_MAX = 500;
export const RAW_UNIT_MAX = 30;
